<template>
  <div class="app-container">
    <el-button icon="el-icon-download" @click="onDownload">下载</el-button>
    <el-divider />
    <el-table :data="statistics.data" stripe border>
      <el-table-column
        v-for="(item, index) in statistics.header"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
      >
        <el-table-column
          v-for="(it, j) in item.children"
          :key="j"
          :label="it.label"
          :prop="it.prop"
          :width="it.width"
        />
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import models from '@/models';
import api from '@/api';

export default {
  data() {
    const statistics = models.statistics();
    return {
      statistics
    };
  },
  async created() {
    const { data } = await api.statistics.summary();
    this.statistics.data = data;
  },
  methods: {
    onDownload() {
      open('api/statistics/exportExcel', '_black');
    }
  }
};
</script>

<style lang="scss" scoped></style>
